"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = arePlayablesDifferent;
/*
 * Copyright 2016 hudl
 * All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @providesModule arePlayablesDifferent
 * 
 *
 * This function compares two sets of playables and tells us if they are different or not
 */

function arePlayablesDifferent(newPlayables, oldPlayables) {
  // 1. When initializing, oldPlayables will be null. So we will want to take the new ones.
  if (!oldPlayables && newPlayables) return true;
  if (!oldPlayables && !newPlayables) return false;

  // 2. if the lengths are different, obvious mismatch
  if (oldPlayables.length !== newPlayables.length) return true;

  // 3. loop over playables and compare on src, startTime, endTime or streams, thumbnailUrl
  //    Those fields are what VideoPlayback care about
  return newPlayables.reduce(function (bool, playable, i) {
    // 3.a. if bool was switched, we have a mismatch. Stick with that truthy value.
    if (bool) return bool;

    var oldPlayable = oldPlayables[i];

    // 4. If playables have streams, compare against them
    //    We basically rerun the function with the streams
    if (playable.streams || oldPlayable.streams) {
      var newIsArray = Array.isArray(playable.streams);
      var oldIsArray = Array.isArray(oldPlayable.streams);
      if (newIsArray !== oldIsArray) {
        return true;
      }
      return arePlayablesDifferent(playable.streams, oldPlayable.streams);
    }

    // 5. Without streams, compare against the values on the playable
    return playable.src !== oldPlayable.src || playable.startTimeMs !== oldPlayable.startTimeMs || playable.endTimeMs !== oldPlayable.endTimeMs || playable.thumbnailUrl !== oldPlayable.thumbnailUrl;
  }, false);
}
module.exports = exports["default"];